export interface IntervalFormValue {
    start_time: string;
    end_time: string;
}

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, index) => {
    const hour = index.toString().padStart(2, "0");
    return {
        value: `${hour}:00`,
        label: `${hour}:00`,
    };
});

export const END_HOUR_OPTIONS = Array.from({ length: 24 }, (_, index) => {
    const hour = (index + 1).toString().padStart(2, "0");
    return {
        value: `${hour}:00`,
        label: `${hour}:00`,
    };
});

export const sanitiseEndOptions = (startValue: string | undefined) => {
    if (!startValue) return END_HOUR_OPTIONS;
    return END_HOUR_OPTIONS.filter((option) => option.value > startValue);
};

const toTimeWithSeconds = (value: string) => `${value}:00`;

const toEndTimeWithSeconds = (value: string) => (value === "24:00" ? "23:59:59" : toTimeWithSeconds(value));

export const normaliseIntervalsForSave = (intervals: IntervalFormValue[]) => {
    const sorted = [...intervals].sort((a, b) => a.start_time.localeCompare(b.start_time));

    return sorted.map((interval) => ({
        start_time: toTimeWithSeconds(interval.start_time),
        end_time: toEndTimeWithSeconds(interval.end_time),
    }));
};

const formatHour = (value: string | null | undefined) => {
    if (!value) return "";
    return value.substring(0, 5);
};

const formatEndHour = (value: string | null | undefined) => {
    if (!value) return "";
    if (value === "23:59:59") return "24:00";
    return formatHour(value);
};

interface IntervalSource {
    start_time?: string | null;
    end_time?: string | null;
}

export const mapStoredIntervalsToForm = (
    stored: IntervalSource[] | null | undefined,
    options?: { fallbackFullDay?: boolean }
) => {
    if (Array.isArray(stored) && stored.length > 0) {
        return stored.map((interval) => ({
            start_time: formatHour(interval.start_time),
            end_time: formatEndHour(interval.end_time),
        }));
    }

    if (options?.fallbackFullDay) {
        return [
            {
                start_time: "00:00",
                end_time: "24:00",
            },
        ];
    }

    return [{ start_time: "", end_time: "" }];
};
